import greycat from '@greycat/core-wasm';
import Keys from './__gen/keys';
export { default as Keys } from './__gen/keys';
export class NodeType {
    constructor(nptr) {
        this.ptr = 0;
        this.ptr = nptr;
    }
    declareFactory(factory) {
        const graph_ptr = greycat._node_type__graph(this.ptr);
        const graph = GreyCat.elements[graph_ptr];
        graph.factories[greycat._gnode_type__key(this.ptr)] = factory;
    }
    declareAttribute(key, value) {
        if (typeof value === 'number') {
            greycat._gnode_type__declare_attribute(this.ptr, GreyCat.paramToKey(key), value);
        }
        else {
            greycat._gnode_type__declare_attribute(this.ptr, GreyCat.paramToKey(key), GreyCat.hash(value));
        }
        return this;
    }
    declareConstant(key, value) {
        if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._node_type__declare_constant_raw_string(this.ptr, GreyCat.paramToKey(key, this), ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                greycat._node_type__declare_constant_double(this.ptr, GreyCat.paramToKey(key, this), value);
            }
            else if (value > -9007199254740992 && value < 9007199254740992) {
                greycat._node_type__declare_constant_int(this.ptr, GreyCat.paramToKey(key, this), value);
            }
            else {
                greycat._node_type__declare_constant_long(this.ptr, GreyCat.paramToKey(key, this), value);
            }
        }
        else if (value instanceof GFunction) {
            greycat._gnode_type__declare_constant(this.ptr, GreyCat.paramToKey(key, this), value.ptr, Keys.g_function);
        }
        else {
            const graph_ptr = greycat._node_type__graph(this.ptr);
            const anonymous_func_ptr = greycat._function__create(graph_ptr);
            GreyCat.elements[anonymous_func_ptr] = value;
            greycat._gnode_type__declare_constant(this.ptr, GreyCat.paramToKey(key, this), anonymous_func_ptr, Keys.g_function);
            greycat._gobject__un_mark(anonymous_func_ptr, Keys.g_function);
        }
        return this;
    }
    declareFunction(key, value) {
        return this;
    }
    toString() {
        const buffer = greycat._gstring__create();
        greycat._gnode_type__json_to(this.ptr, buffer);
        greycat._gstring__close(buffer);
        const buffer_raw = greycat._gstring__get(buffer);
        const result = greycat.Pointer_stringify(buffer_raw);
        greycat._gobject__un_mark(buffer, Keys.g_string);
        return result;
    }
}
export class Task {
    constructor(nptr) {
        this.ptr = 0;
        this.userData = {};
        this.ptr = nptr;
    }
    execute(f) {
        if (typeof f === 'number') {
            greycat._gtask__execute_key(this.ptr, f);
        }
        else if (typeof f === 'string') {
            greycat._gtask__execute_key(this.ptr, GreyCat.hash(f));
        }
        else {
            greycat._gtask__execute(this.ptr, f.ptr);
        }
    }
    prepareExecute(f) {
        if (typeof f === 'number') {
            greycat._gtask__prepare_execute_key(this.ptr, f);
        }
        else if (typeof f === 'string') {
            greycat._gtask__prepare_execute_key(this.ptr, GreyCat.hash(f));
        }
        else {
            greycat._gtask__prepare_call(this.ptr, f.ptr);
        }
        return this;
    }
    executePrepared() {
        greycat._gtask__execute_prepared(this.ptr);
    }
    ordinal() {
        return greycat._gtask__ordinal(this.ptr);
    }
    onEnd(body) {
        if (body instanceof GFunction) {
            greycat._gtask__on_end(this.ptr, body.ptr);
        }
        else {
            const final_func_ptr = greycat._function__create(greycat._gtask__graph(this.ptr));
            GreyCat.elements[final_func_ptr] = body;
            greycat._gtask__on_end(this.ptr, final_func_ptr);
            greycat._gobject__un_mark(final_func_ptr, Keys.g_function);
        }
        return this;
    }
    path() {
        const strPtr = greycat._gtask__path(this.ptr);
        const jsStr = greycat.Pointer_stringify(strPtr);
        greycat._js_free(strPtr);
        return jsStr;
    }
    toString() {
        const strPtr = greycat._gtask__json(this.ptr);
        const jsStr = greycat.Pointer_stringify(strPtr);
        greycat._js_free(strPtr);
        return jsStr;
    }
    toObject() {
        return JSON.parse(this.toString());
    }
    declare(key, value) {
        if (!value) {
            greycat._gtask__declare_null(this.ptr, GreyCat.paramToKey(key, this));
        }
        else if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._gtask__declare_raw_string(this.ptr, GreyCat.paramToKey(key, this), ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (value % 1 !== 0) {
            greycat._gtask__declare_double(this.ptr, GreyCat.paramToKey(key, this), value);
        }
        else if (value > -9007199254740992 && value < 9007199254740992) {
            greycat._gtask__declare_int(this.ptr, GreyCat.paramToKey(key, this), value);
        }
        else {
            greycat._gtask__declare_long(this.ptr, GreyCat.paramToKey(key, this), value);
        }
        return this;
    }
    set(key, value) {
        if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._gtask__set_raw_string(this.ptr, GreyCat.paramToKey(key, this), ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                greycat._gtask__set_double(this.ptr, GreyCat.paramToKey(key, this), value);
            }
            else if (value > -9007199254740992 && value < 9007199254740992) {
                greycat._gtask__set_int(this.ptr, GreyCat.paramToKey(key, this), value);
            }
        }
        else if (typeof value === 'boolean') {
            greycat._gtask__set_long(this.ptr, GreyCat.paramToKey(key, this), value);
        }
        else if (value instanceof GFunction) {
            greycat._gtask__set_long(this.ptr, GreyCat.paramToKey(key, this), value.ptr);
        }
        else {
        }
        return this;
    }
    get(prop) {
        const propKey = GreyCat.paramToKey(prop);
        const type = greycat._task__type(this.ptr, propKey);
        switch (type) {
            case Keys.g_double:
                return greycat._gtask__get_double(this.ptr, propKey);
            case Keys.g_int:
                return greycat._gtask__get_int(this.ptr, propKey);
            case Keys.g_long:
                return greycat._gtask__get_long(this.ptr, propKey);
            case Keys.g_ulong:
                return greycat._gtask__get_ulong(this.ptr, propKey);
            case Keys.g_bool:
                return greycat._gtask__get_bool(this.ptr, propKey) === 1;
            case Keys.g_string: {
                const ptr = greycat._gtask__get_raw_string(this.ptr, propKey);
                return ptr !== 0 ? greycat.Pointer_stringify(ptr) : null;
            }
            case Keys.g_string_array: {
                const ptr = greycat._task__get(this.ptr, propKey);
                return ptr !== 0 ? new StringArray(ptr) : null;
            }
            case Keys.g_long_array: {
                const ptr = greycat._task__get(this.ptr, propKey);
                return ptr !== 0 ? new LongArray(ptr) : null;
            }
            case Keys.g_ulong_array: {
                const ptr = greycat._task__get(this.ptr, propKey);
                return ptr !== 0 ? new ULongArray(ptr) : null;
            }
            case Keys.g_int_array: {
                const ptr = greycat._task__get(this.ptr, propKey);
                return ptr !== 0 ? new IntArray(ptr) : null;
            }
            case Keys.g_double_array: {
                const ptr = greycat._task__get(this.ptr, propKey);
                return ptr !== 0 ? new DoubleArray(ptr) : null;
            }
            default: {
                const ptr = greycat._task__get(this.ptr, propKey);
                if (ptr === 0) {
                    return null;
                }
                else {
                    const graph_ptr = greycat._gtask__graph(this.ptr);
                    const graph = GreyCat.elements[graph_ptr];
                    const factory = graph.factories[type];
                    if (factory !== undefined) {
                        return factory(ptr);
                    }
                    else {
                        return new GNode(ptr);
                    }
                }
            }
        }
    }
    bind(src, target) {
        greycat._gtask__bind(this.ptr, GreyCat.paramToKey(src, this), GreyCat.paramToKey(target, this));
        return this;
    }
}
export class ULongArray {
    constructor(nptr) {
        this.ptr = 0;
        this.ptr = nptr;
    }
    deleteRef() {
        if (this.ptr !== 0) {
            greycat._gobject__un_mark(this.ptr, Keys.g_ulong_array);
            this.ptr = 0;
        }
    }
    toString() {
        const raw_c_str = greycat._ulong_array__to_string(this.ptr);
        const ts_str = greycat.Pointer_stringify(raw_c_str);
        greycat._js_free(ts_str);
        return ts_str;
    }
    get(offset) {
        return greycat._gulong_array__get(this.ptr, offset);
    }
    set(offset, value) {
        greycat._gulong_array__set(this.ptr, offset, value);
        return this;
    }
    add(value) {
        return greycat._gulong_array__add(this.ptr, value);
    }
    size() {
        return greycat._gulong_array__size(this.ptr);
    }
}
export class LongArray {
    constructor(nptr) {
        this.ptr = 0;
        this.ptr = nptr;
    }
    deleteRef() {
        if (this.ptr !== 0) {
            greycat._gobject__un_mark(this.ptr, Keys.g_long_array);
            this.ptr = 0;
        }
    }
    toString() {
        const raw_c_str = greycat._long_array__to_string(this.ptr);
        const ts_str = greycat.Pointer_stringify(raw_c_str);
        greycat._js_free(ts_str);
        return ts_str;
    }
    get(offset) {
        return greycat._glong_array__get(this.ptr, offset);
    }
    set(offset, value) {
        greycat._glong_array__set(this.ptr, offset, value);
        return this;
    }
    add(value) {
        return greycat._glong_array__add(this.ptr, value);
    }
    size() {
        return greycat._glong_array__size(this.ptr);
    }
}
export class IntArray {
    constructor(nptr) {
        this.ptr = 0;
        this.ptr = nptr;
    }
    deleteRef() {
        if (this.ptr !== 0) {
            greycat._gobject__un_mark(this.ptr, Keys.g_int_array);
            this.ptr = 0;
        }
    }
    toString() {
        const raw_c_str = greycat._int_array__to_string(this.ptr);
        const ts_str = greycat.Pointer_stringify(raw_c_str);
        greycat._js_free(ts_str);
        return ts_str;
    }
    get(offset) {
        return greycat._gint_array__get(this.ptr, offset);
    }
    set(offset, value) {
        greycat._gint_array__set(this.ptr, offset, value);
        return this;
    }
    add(value) {
        return greycat._gint_array__add(this.ptr, value);
    }
    size() {
        return greycat._gint_array__size(this.ptr);
    }
}
export class DoubleArray {
    constructor(nptr) {
        this.ptr = 0;
        this.ptr = nptr;
    }
    deleteRef() {
        if (this.ptr !== 0) {
            greycat._gobject__un_mark(this.ptr, Keys.g_double_array);
            this.ptr = 0;
        }
    }
    toString() {
        const raw_c_str = greycat._double_array__to_string(this.ptr);
        const ts_str = greycat.Pointer_stringify(raw_c_str);
        greycat._js_free(ts_str);
        return ts_str;
    }
    get(offset) {
        return greycat._gdouble_array__get(this.ptr, offset);
    }
    set(offset, value) {
        greycat._gdouble_array__set(this.ptr, offset, value);
        return this;
    }
    add(value) {
        return greycat._gdouble_array__add(this.ptr, value);
    }
    size() {
        return greycat._gdouble_array__size(this.ptr);
    }
}
export class StringArray {
    constructor(nptr) {
        this.ptr = 0;
        this.ptr = nptr;
    }
    deleteRef() {
        if (this.ptr !== 0) {
            greycat._gobject__un_mark(this.ptr, Keys.g_string_array);
            this.ptr = 0;
        }
    }
    toString() {
        const raw_c_str = greycat._string_array__to_string(this.ptr);
        const ts_str = greycat.Pointer_stringify(raw_c_str);
        greycat._js_free(ts_str);
        return ts_str;
    }
    get(offset) {
        const gstring_ptr = greycat._gstring_array__get(this.ptr, offset);
        return greycat.Pointer_stringify(greycat._gstring__get(gstring_ptr));
    }
    set(offset, value) {
        const new_str_ptr = greycat._gstring__create();
        greycat._gstring__prepare(new_str_ptr, value.length + 1);
        const new_ptr_raw = greycat._gstring__get(new_str_ptr);
        greycat.writeAsciiToMemory(value, new_ptr_raw, false);
        greycat._string__set_size(new_str_ptr, value.length);
        greycat._gstring__close(new_str_ptr);
        greycat._gstring_array__set(this.ptr, offset, new_str_ptr);
        greycat._gobject__un_mark(new_str_ptr, Keys.g_string_array);
        return this;
    }
    add(value) {
        const new_gstring = greycat._gstring_array__add(this.ptr);
        greycat._gstring__prepare(new_gstring, value.length + 1);
        const new_ptr_raw = greycat._gstring__get(new_gstring);
        greycat.writeAsciiToMemory(value, new_ptr_raw, false);
        greycat._string__set_size(new_gstring, value.length);
        greycat._gstring__close(new_gstring);
        return this;
    }
    values(...new_values) {
        for (let i = 0; i < new_values.length; i++) {
            this.add(new_values[i]);
        }
    }
    size() {
        return greycat._gstring_array__size(this.ptr);
    }
}
export class Param {
    constructor(type_code, key, value) {
        this.type_code = type_code;
        this.key = key;
        this.value = value;
    }
}
export class Params {
    constructor(capacity) {
        this.ptr = 0;
        this.ptr = greycat._params__create(capacity);
    }
    addInt(key, value) {
        greycat._params__add_int(this.ptr, GreyCat.paramToKey(key), value);
        return this;
    }
    addLong(key, value) {
        greycat._params__add_long(this.ptr, GreyCat.paramToKey(key), value);
        return this;
    }
    addDouble(key, value) {
        greycat._params__add_double(this.ptr, GreyCat.paramToKey(key), value);
        return this;
    }
    addBool(key, value) {
        greycat._params__add_bool(this.ptr, GreyCat.paramToKey(key), value);
        return this;
    }
    addNull(key) {
        greycat._params__add_null(this.ptr, GreyCat.paramToKey(key));
        return this;
    }
    addVarKey(key, value) {
        greycat._params__add_var_key(this.ptr, GreyCat.paramToKey(key), value);
        return this;
    }
    addVarKeyNew(key, value) {
        greycat._params__add_var_key_new(this.ptr, GreyCat.paramToKey(key), value);
        return this;
    }
    addFunctionKey(key, value) {
        greycat._params__add_function_key(this.ptr, GreyCat.paramToKey(key), value);
        return this;
    }
    addString(key, value) {
        const ptr_str = greycat._js_malloc(value.length + 1);
        greycat.writeAsciiToMemory(value, ptr_str, false);
        greycat._params__add_string(this.ptr, GreyCat.paramToKey(key), ptr_str);
        greycat._js_free(ptr_str);
        return this;
    }
    addObject(key, value) {
        if (value instanceof ULongArray) {
            greycat._params__add_object(this.ptr, GreyCat.paramToKey(key), Keys.g_ulong_array, value.ptr);
        }
        else if (value instanceof LongArray) {
            greycat._params__add_object(this.ptr, GreyCat.paramToKey(key), Keys.g_long_array, value.ptr);
        }
        else if (value instanceof IntArray) {
            greycat._params__add_object(this.ptr, GreyCat.paramToKey(key), Keys.g_int_array, value.ptr);
        }
        else if (value instanceof DoubleArray) {
            greycat._params__add_object(this.ptr, GreyCat.paramToKey(key), Keys.g_double_array, value.ptr);
        }
        else if (value instanceof GFunction) {
            greycat._params__add_object(this.ptr, GreyCat.paramToKey(key), Keys.g_function, value.ptr);
        }
        return this;
    }
    addTypedObject(key, value, type) {
        greycat._params__add_object(this.ptr, GreyCat.paramToKey(key), type, value);
        return this;
    }
    addAuto(key, value) {
        const ikey = GreyCat.paramToKey(key);
        if (value instanceof ULongArray ||
            value instanceof LongArray ||
            value instanceof IntArray ||
            value instanceof DoubleArray) {
            greycat._params__add_object(this.ptr, ikey, value.ptr);
        }
        else if (typeof value === 'string') {
            this.addString(ikey, value);
        }
        else if (typeof value === 'boolean') {
            this.addBool(ikey, value);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                this.addDouble(ikey, value);
            }
            else if (value > -9007199254740992 && value < 9007199254740992) {
                this.addInt(ikey, value);
            }
            else {
                this.addLong(ikey, value);
            }
        }
        else if (value instanceof GFunction) {
            this.addFunctionKey(key, value.ptr);
        }
        return this;
    }
}
export class GFunction {
    constructor(nptr) {
        this.ptr = 0;
        this.ptr = nptr;
    }
    static params(capacity) {
        return new Params(capacity);
    }
    deleteRef() {
        if (this.ptr !== 0) {
            greycat._gobject__un_mark(this.ptr, Keys.g_function);
            this.ptr = 0;
        }
    }
    name(name) {
        greycat._gfunction__unsafe_set_key(this.ptr, GreyCat.paramToKey(name, this));
        return this;
    }
    pipe(sub, params) {
        if (typeof sub === 'string') {
            if (params) {
                greycat._function__pipe_key_with(this.ptr, GreyCat.hash(sub), params.ptr);
            }
            else {
                greycat._gfunction__pipe_key(this.ptr, GreyCat.hash(sub));
            }
        }
        else if (typeof sub === 'number') {
            if (params) {
                greycat._function__pipe_key_with(this.ptr, sub, params.ptr);
            }
            else {
                greycat._gfunction__pipe_key(this.ptr, sub);
            }
        }
        else if (sub instanceof GFunction) {
            if (params) {
                greycat._function__pipe_with(this.ptr, sub.ptr, params.ptr);
            }
            else {
                greycat._gfunction__pipe(this.ptr, sub.ptr);
            }
        }
        else {
            const sub_ptr = greycat._function__create(greycat._gtask__graph(this.ptr));
            GreyCat.elements[sub_ptr] = sub;
            if (params) {
                greycat._function__pipe_with(this.ptr, sub_ptr, params.ptr);
            }
            else {
                greycat._gfunction__pipe(this.ptr, sub_ptr);
            }
            greycat._gobject__un_mark(sub_ptr, Keys.g_function);
        }
        return this;
    }
    parse(greycatl_data) {
        const ptr_str = greycat._js_malloc(greycatl_data.length + 1);
        greycat.writeAsciiToMemory(greycatl_data, ptr_str, false);
        const result = greycat._gfunction__parse(this.ptr, ptr_str);
        greycat._js_free(ptr_str);
        if (!result) {
            throw new Error('GreyCat parse error');
        }
        return this;
    }
    sync() {
        this.pipe(Keys.g_sync);
        return this;
    }
    declareVar(value, targetVar) {
        this.pipe(Keys.g_declare_var, GFunction.params(2)
            .addAuto(Keys.g_value, value)
            .addVarKeyNew(Keys.g_result, GreyCat.paramToKey(targetVar)));
        return this;
    }
    assignVar(value, targetVar) {
        this.pipe(Keys.g_assign_var, GFunction.params(2)
            .addAuto(Keys.g_value, value)
            .addVarKey(Keys.g_result, GreyCat.paramToKey(targetVar)));
        return this;
    }
    print(srcVar, targetVar) {
        this.pipe(Keys.g_print, GFunction.params(2)
            .addVarKey(Keys.g_src, GreyCat.paramToKey(srcVar))
            .addVarKey(Keys.g_result, targetVar ? GreyCat.paramToKey(targetVar) : Keys.g_console));
        return this;
    }
    printAll(targetVar) {
        this.pipe(Keys.g_print_all, GFunction.params(1).addVarKey(Keys.g_result, targetVar ? GreyCat.paramToKey(targetVar) : Keys.g_console));
        return this;
    }
    newNode(nodeType, targetVar) {
        this.pipe(Keys.g_new_node, GFunction.params(2)
            .addInt(Keys.g_node_type, GreyCat.paramToKey(nodeType))
            .addVarKey(Keys.g_result, GreyCat.paramToKey(targetVar)));
        return this;
    }
    newTimepoint(srcVar, timestamp, targetVar) {
        this.pipe(Keys.g_new_timepoint, GFunction.params(3)
            .addVarKey(Keys.g_src, GreyCat.paramToKey(srcVar))
            .addLong(Keys.g_time, timestamp)
            .addVarKey(Keys.g_result, GreyCat.paramToKey(targetVar)));
        return this;
    }
    setAttribute(value, targetVar, property) {
        this.pipe(Keys.g_set_attribute, GFunction.params(3)
            .addAuto(Keys.g_value, value)
            .addVarKey(Keys.g_result, GreyCat.paramToKey(targetVar))
            .addInt(Keys.g_prop, GreyCat.paramToKey(property)));
        return this;
    }
    setReference(srcVar, targetVar, property) {
        this.pipe(Keys.g_set_reference, GFunction.params(3)
            .addVarKey(Keys.g_src, GreyCat.paramToKey(srcVar))
            .addVarKey(Keys.g_result, GreyCat.paramToKey(targetVar))
            .addInt(Keys.g_prop, GreyCat.paramToKey(property)));
        return this;
    }
    readProperty(srcVar, property, targetVar) {
        this.pipe(Keys.g_read_property, GFunction.params(3)
            .addVarKey(Keys.g_src, GreyCat.paramToKey(srcVar))
            .addInt(Keys.g_prop, GreyCat.paramToKey(property))
            .addVarKey(Keys.g_result, GreyCat.paramToKey(targetVar)));
        return this;
    }
    repeat(nb_iteration, ordinal, sub) {
        if (typeof sub === 'number') {
            this.pipe(Keys.g_repeat, GFunction.params(3)
                .addInt(Keys.g_nb, nb_iteration)
                .addInt(Keys.g_it, GreyCat.paramToKey(ordinal))
                .addFunctionKey(Keys.g_sub, sub));
        }
        else if (sub instanceof GFunction) {
            this.pipe(Keys.g_repeat, GFunction.params(3)
                .addInt(Keys.g_nb, nb_iteration)
                .addInt(Keys.g_it, GreyCat.paramToKey(ordinal))
                .addTypedObject(Keys.g_sub, sub.ptr, Keys.g_function));
        }
        else {
            const sub_ptr = greycat._function__create(greycat._gtask__graph(this.ptr));
            GreyCat.elements[sub_ptr] = sub;
            this.pipe(Keys.g_repeat, GFunction.params(3)
                .addInt(Keys.g_nb, nb_iteration)
                .addInt(Keys.g_it, GreyCat.paramToKey(ordinal))
                .addTypedObject(Keys.g_sub, sub_ptr, Keys.g_function));
            greycat._gobject__un_mark(sub_ptr, Keys.g_function);
        }
        return this;
    }
    foreach(src, target, sub) {
        if (typeof sub === 'number') {
            this.pipe(Keys.g_foreach, GFunction.params(3)
                .addVarKey(Keys.g_src, GreyCat.paramToKey(src))
                .addInt(Keys.g_it, GreyCat.paramToKey(target))
                .addFunctionKey(Keys.g_sub, sub));
        }
        else if (sub instanceof GFunction) {
            this.pipe(Keys.g_foreach, GFunction.params(3)
                .addVarKey(Keys.g_src, GreyCat.paramToKey(src))
                .addInt(Keys.g_it, GreyCat.paramToKey(target))
                .addTypedObject(Keys.g_sub, sub.ptr, Keys.g_function));
        }
        else {
            const sub_ptr = greycat._function__create(greycat._gtask__graph(this.ptr));
            GreyCat.elements[sub_ptr] = sub;
            this.pipe(Keys.g_foreach, GFunction.params(3)
                .addVarKey(Keys.g_src, GreyCat.paramToKey(src))
                .addInt(Keys.g_it, GreyCat.paramToKey(target))
                .addTypedObject(Keys.g_sub, sub_ptr, Keys.g_function));
            greycat._gobject__un_mark(sub_ptr, Keys.g_function);
        }
        return this;
    }
    loadGlobalIndex(index, target) {
        this.pipe(Keys.g_load_global_index, GFunction.params(2)
            .addString(Keys.g_id, index)
            .addVarKey(Keys.g_result, GreyCat.paramToKey(target)));
        return this;
    }
    newGlobalIndex(index, target) {
        this.pipe(Keys.g_new_global_index, GFunction.params(2)
            .addString(Keys.g_id, index)
            .addVarKey(Keys.g_result, GreyCat.paramToKey(target)));
        return this;
    }
    loadMasterIndex(target) {
        this.pipe(Keys.g_load_master_index, GFunction.params(1).addVarKey(Keys.g_result, GreyCat.paramToKey(target)));
        return this;
    }
    configureIndex(target, property) {
        this.pipe(Keys.g_configure_index, GFunction.params(2)
            .addVarKey(Keys.g_result, GreyCat.paramToKey(target))
            .addInt(Keys.g_prop, GreyCat.paramToKey(property)));
        return this;
    }
    addToIndex(src, target) {
        this.pipe(Keys.g_add_to_index, GFunction.params(2)
            .addVarKey(Keys.g_src, GreyCat.paramToKey(src))
            .addVarKey(Keys.g_result, GreyCat.paramToKey(target)));
        return this;
    }
    queryIndex(src, value, target) {
        this.pipe(Keys.g_query_index, GFunction.params(3)
            .addVarKey(Keys.g_src, GreyCat.paramToKey(src))
            .addAuto(Keys.g_value, value)
            .addVarKey(Keys.g_result, GreyCat.paramToKey(target)));
        return this;
    }
}
export class Plugin {
    start(graph) {
    }
    stop(graph) {
    }
}
export class GNode {
    constructor(nptr) {
        this.ptr = nptr;
    }
    toString() {
        const strPtr = greycat._gnode__json(this.ptr);
        const jsStr = greycat.Pointer_stringify(strPtr);
        greycat._js_free(strPtr);
        return jsStr;
    }
    toObject() {
        return JSON.parse(this.toString());
    }
    set(key, value) {
        if (value === null) {
            greycat._gnode__set_null(this.ptr, GreyCat.paramToKey(key, this));
        }
        else if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._gnode__set_raw_string(this.ptr, GreyCat.paramToKey(key, this), ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                greycat._gnode__set_double(this.ptr, GreyCat.paramToKey(key, this), value);
            }
            else if (value > -9007199254740992 && value < 9007199254740992) {
                greycat._gnode__set_int(this.ptr, GreyCat.paramToKey(key, this), value);
            }
            else {
                greycat._gnode__set_long(this.ptr, GreyCat.paramToKey(key, this), value);
            }
        }
        else if (value instanceof GFunction) {
            greycat._gnode__set(this.ptr, GreyCat.paramToKey(key, this), value.ptr, Keys.g_function);
        }
        else {
            const graph_ptr = greycat._node__graph(this.ptr);
            const anonymous_func_ptr = greycat._function__create(graph_ptr);
            GreyCat.elements[anonymous_func_ptr] = value;
            greycat._gnode__set(this.ptr, GreyCat.paramToKey(key, this), anonymous_func_ptr, Keys.g_function);
            greycat._gobject__un_mark(anonymous_func_ptr, Keys.g_function);
        }
        return this;
    }
    get(key) {
        const pkey = GreyCat.paramToKey(key);
        const ptype = greycat._node__type(this.ptr, pkey);
        switch (ptype) {
            case Keys.g_null:
            case Keys.g_empty:
                return null;
            case Keys.g_bool:
                return greycat._gnode__get_bool(this.ptr, pkey) === 1;
            case Keys.g_long:
            case Keys.g_ulong:
                return greycat._gnode__get_long(this.ptr, pkey);
            case Keys.g_double:
                return greycat._gnode__get_double(this.ptr, pkey);
            case Keys.g_int:
                return greycat._gnode__get_int(this.ptr, pkey);
            case Keys.g_string: {
                const string_ptr = greycat._gnode__get_raw_string(this.ptr, pkey);
                if (string_ptr !== 0) {
                    return greycat.Pointer_stringify(string_ptr);
                }
                else {
                    return null;
                }
            }
            case Keys.g_ulong_array: {
                return new ULongArray(greycat._node__get(this.ptr, pkey));
            }
            case Keys.g_long_array: {
                return new LongArray(greycat._node__get(this.ptr, pkey));
            }
            case Keys.g_int_array: {
                return new IntArray(greycat._node__get(this.ptr, pkey));
            }
            case Keys.g_double_array: {
                return new DoubleArray(greycat._node__get(this.ptr, pkey));
            }
            default: {
                const ptr = greycat._node__get(this.ptr, pkey);
                const graph_ptr = greycat._node__graph(this.ptr);
                const graph = GreyCat.elements[graph_ptr];
                const factory = graph.factories[ptype];
                if (factory !== undefined) {
                    return factory(ptr);
                }
                else {
                    return new GNode(ptr);
                }
            }
        }
    }
    getOrCreate(key, prop_type) {
        const pkey = GreyCat.paramToKey(key, this);
        const ptype = GreyCat.paramToKey(prop_type);
        const res_ptr = greycat._gnode__get_or_create(this.ptr, pkey, ptype);
        switch (ptype) {
            case Keys.g_null:
            case Keys.g_empty:
                return null;
            case Keys.g_bool:
                return greycat._read_bool(res_ptr) === 1;
            case Keys.g_long:
                return greycat._read_ulong(res_ptr);
            case Keys.g_ulong:
                return greycat._read_long(res_ptr);
            case Keys.g_double:
                return greycat._read_double(res_ptr);
            case Keys.g_int:
                return greycat._read_int(res_ptr);
            case Keys.g_string: {
                const string_ptr = greycat._gnode__get_raw_string(this.ptr, pkey);
                if (string_ptr !== 0) {
                    return greycat.Pointer_stringify(string_ptr);
                }
                else {
                    return null;
                }
            }
            case Keys.g_ulong_array: {
                return new ULongArray(res_ptr);
            }
            case Keys.g_long_array: {
                return new LongArray(res_ptr);
            }
            case Keys.g_int_array: {
                return new IntArray(res_ptr);
            }
            case Keys.g_double_array: {
                return new DoubleArray(res_ptr);
            }
            default: {
                const graph_ptr = greycat._node__graph(this.ptr);
                const graph = GreyCat.elements[graph_ptr];
                const factory = graph.factories[ptype];
                if (factory !== undefined) {
                    return factory(res_ptr);
                }
                else {
                    return new GNode(res_ptr);
                }
            }
        }
    }
    deleteRef() {
        if (this.ptr !== 0) {
            greycat._gobject__un_mark(this.ptr, Keys.g_node);
            this.ptr = 0;
        }
    }
}
export class Graph {
    constructor(cacheSize, bufferSize) {
        this.ptr = 0;
        this.factories = {};
        if (cacheSize === undefined) {
            cacheSize = 1000;
        }
        if (bufferSize === undefined) {
            bufferSize = 10;
        }
        this.ptr = greycat._graph__create(cacheSize, bufferSize);
        GreyCat.elements[this.ptr] = this;
    }
    enableDebug() {
        greycat._ggraph__enable_debug(this.ptr);
    }
    disableDebug() {
        greycat._ggraph__disable_debug(this.ptr);
    }
    declareMeta(meta_key, meta) {
        if (greycat._ggraph__is_meta(this.ptr, meta_key) === 0) {
            const buffer = greycat._js_malloc(meta.length + 1);
            greycat.writeAsciiToMemory(meta, buffer, false);
            greycat._ggraph__declare_meta(this.ptr, meta_key, buffer);
            greycat._js_free(buffer);
        }
    }
    declareFunction(id, func) {
        if (func instanceof GFunction) {
            greycat._ggraph__declare_function(this.ptr, GreyCat.paramToKey(id, this), func.ptr);
        }
        else {
            const ptr = greycat._function__create(this.ptr);
            GreyCat.elements[ptr] = func;
            greycat._ggraph__declare_function(this.ptr, GreyCat.paramToKey(id, this), ptr);
            greycat._gobject__un_mark(ptr, Keys.g_function);
        }
    }
    declareType(id) {
        return new NodeType(greycat._ggraph__declare_type(this.ptr, GreyCat.paramToKey(id, this)));
    }
    declarePlugin(plugin) {
        const plug_ptr = greycat._plugin__create();
        GreyCat.elements[plug_ptr] = plugin;
        greycat._ggraph__declare_plugin(this.ptr, plug_ptr);
        return this;
    }
    configurePlugin(plugin, params) {
        greycat._graph__configure_plugin(this.ptr, GreyCat.paramToKey(plugin), params.ptr);
        return this;
    }
    newFunction(body) {
        if (body !== undefined) {
            const ptr = greycat._function__create(this.ptr);
            GreyCat.elements[ptr] = body;
            return new GFunction(ptr);
        }
        else {
            return new GFunction(greycat._gfunction__create(this.ptr));
        }
    }
    getFunction(id) {
        const ptr = greycat._ggraph__function(this.ptr, GreyCat.paramToKey(id, this));
        if (ptr === 0) {
            return null;
        }
        else {
            return new GFunction(ptr);
        }
    }
    getType(id) {
        const type_ptr = greycat._ggraph__type(this.ptr, GreyCat.paramToKey(id, this));
        if (type_ptr === 0) {
            return null;
        }
        else {
            return new NodeType(type_ptr);
        }
    }
    getMeta(id) {
        const gstring_ptr = greycat._ggraph__meta(this.ptr, GreyCat.paramToKey(id, this));
        if (gstring_ptr === 0) {
            return null;
        }
        return greycat.Pointer_stringify(gstring_ptr);
    }
    newAnonymousFunction(body) {
        let ptr;
        if (body !== undefined) {
            ptr = greycat._function__create(this.ptr);
            GreyCat.elements[ptr] = body;
        }
        else {
            ptr = greycat._gfunction__create(this.ptr);
        }
        greycat._gfunction__unsafe_dec_ref(ptr);
        return new GFunction(ptr);
    }
    newTask() {
        const ptr = greycat._task__create(this.ptr);
        const task = new Task(ptr);
        GreyCat.elements[ptr] = task;
        return task;
    }
    newVolatile(type) {
        const vtype = GreyCat.paramToKey(type);
        switch (vtype) {
            case Keys.g_string_array:
                return new StringArray(greycat._gstring_array__create(this.ptr));
            default:
                const ptr = greycat._ggraph__create_node_volatile(this.ptr, vtype);
                if (ptr === 0) {
                    return null;
                }
                else {
                    const factory = this.factories[vtype];
                    if (factory !== undefined) {
                        return factory(ptr);
                    }
                    else {
                        return new GNode(ptr);
                    }
                }
        }
    }
    exportTypes() {
        const buffer = greycat._gstring__create();
        greycat._ggraph_export_types(this.ptr, buffer);
        greycat._gstring__close(buffer);
        const buffer_raw = greycat._gstring__get(buffer);
        const result = greycat.Pointer_stringify(buffer_raw);
        greycat._gobject__un_mark(buffer, Keys.g_string);
        return result;
    }
    exportFunctions() {
        const buffer = greycat._gstring__create();
        greycat._ggraph_export_functions(this.ptr, buffer);
        greycat._gstring__close(buffer);
        const buffer_raw = greycat._gstring__get(buffer);
        const result = greycat.Pointer_stringify(buffer_raw);
        greycat._gobject__un_mark(buffer, Keys.g_string);
        return result;
    }
    destroy() {
        if (this.ptr !== 0) {
            delete GreyCat.elements[this.ptr];
            greycat._ggraph__destroy(this.ptr);
            this.ptr = 0;
        }
    }
    heapSize() {
        return greycat._graph__size_heap(this.ptr);
    }
    cacheSize() {
        return greycat._graph__size_cache(this.ptr);
    }
    bufferSize() {
        return greycat._graph__size_buffer(this.ptr);
    }
}
export class WebSocketAdapter {
    constructor(s) {
        this.buffer = [];
        this.socket = s;
        this.connected = false;
    }
}
export class GreyCat {
    static onReady(callback) {
        if (this.isInitiliazed) {
            callback();
        }
        else {
            greycat.onRuntimeInitialized = () => {
                this.isInitiliazed = true;
                callback();
            };
        }
    }
    static newGraph(cacheSize, bufferSize) {
        return new Graph(cacheSize, bufferSize);
    }
    static newWebSocketClient(nptr, url_ptr, port) {
        const address = greycat.Pointer_stringify(url_ptr);
        const socket = new WebSocket('ws://' + address + ':' + port, 'default');
        socket.binaryType = 'arraybuffer';
        const ws = new WebSocketAdapter(socket);
        socket.onopen = (e) => {
            ws.connected = true;
            for (let i = 0; i < ws.buffer.length; i++) {
                socket.send(ws.buffer[i].buffer);
            }
            ws.buffer = [];
        };
        socket.onclose = (e) => {
            ws.connected = false;
        };
        socket.onerror = (e) => {
            console.error(e);
        };
        socket.onmessage = (m_ev) => {
            const msgBuf = new Uint8Array(m_ev.data);
            const bug_len = msgBuf.length;
            const buf = greycat._js_malloc(bug_len);
            greycat.HEAPU8.set(msgBuf, buf);
            greycat._gwebsocket_client__on_msg(nptr, buf, bug_len);
            greycat._js_free(buf);
        };
        GreyCat.elements[nptr] = ws;
    }
    static destroyWebSocketClient(nptr) {
        const ws = GreyCat.elements[nptr];
        ws.socket.close();
        delete GreyCat.elements[nptr];
    }
    static webSocketClientSend(client_id, data_ptr, len) {
        const ws = GreyCat.elements[client_id];
        const new_buffer = new Uint8Array(greycat.buffer).slice(data_ptr, data_ptr + len);
        if (!ws.connected) {
            ws.buffer.push(new Uint8Array(new_buffer));
        }
        else {
            ws.socket.send(new_buffer.buffer);
        }
    }
    static hash(str) {
        let hash = 0;
        let char;
        if (str.length === 0) {
            return hash;
        }
        for (let i = 0; i < str.length; i++) {
            char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash;
        }
        return hash;
    }
    static paramToKey(param, origin) {
        if (typeof param === 'string') {
            const paramHash = GreyCat.hash(param);
            if (origin !== undefined) {
                let graph_ptr;
                if (origin instanceof GFunction) {
                    graph_ptr = greycat._gfunction__graph(origin.ptr);
                }
                else if (origin instanceof Graph) {
                    graph_ptr = origin.ptr;
                }
                else if (origin instanceof NodeType) {
                    graph_ptr = greycat._node_type__graph(origin.ptr);
                }
                else if (origin instanceof GNode) {
                    graph_ptr = greycat._node__graph(origin.ptr);
                }
                else if (origin instanceof Task) {
                    graph_ptr = greycat._gtask__graph(origin.ptr);
                }
                if (greycat._ggraph__is_meta(graph_ptr, paramHash) === 0) {
                    const meta = param;
                    const buffer = greycat._js_malloc(meta.length + 1);
                    greycat.writeAsciiToMemory(meta, buffer, false);
                    greycat._ggraph__declare_meta(graph_ptr, paramHash, buffer);
                    greycat._js_free(buffer);
                }
            }
            return paramHash;
        }
        else {
            return param;
        }
    }
}
GreyCat._module = greycat;
GreyCat.elements = {};
GreyCat.isInitiliazed = false;
export function intParam(key, value) {
    return new Param(Keys.g_int, GreyCat.paramToKey(key), value);
}
export function longParam(key, value) {
    return new Param(Keys.g_long, GreyCat.paramToKey(key), value);
}
export function doubleParam(key, value) {
    return new Param(Keys.g_double, GreyCat.paramToKey(key), value);
}
export function boolParam(key, value) {
    return new Param(Keys.g_bool, GreyCat.paramToKey(key), value);
}
export function nullParam(key) {
    return new Param(Keys.g_null, GreyCat.paramToKey(key), 0);
}
export function varKeyParam(key, value) {
    return new Param(Keys.g_var_key, GreyCat.paramToKey(key), value);
}
export function functionKeyParam(key, value) {
    return new Param(Keys.g_function_key, GreyCat.paramToKey(key), value);
}
export function stringParam(key, value) {
    return new Param(Keys.g_string, GreyCat.paramToKey(key), value);
}
global.GreyCat = GreyCat;
//# sourceMappingURL=greycat.js.map